import React from 'react';
import {  } from "@chakra-ui/react";
import {
  
  CheckboxSingleControl,
  
} from "formik-chakra-ui";

function CheckboxInput(props) {
    const {name,type,inputValue,title,placeholder,list} = props
    const [value, setValue] = React.useState('')
    const handleChange = (event) => setValue(event.target.value)
    return(
        <>
            <CheckboxSingleControl name={name} style={props.style}>
            {title}
          </CheckboxSingleControl>
            
        </>
    );
}

export default CheckboxInput;